import React, { createContext, useState } from 'react';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedAddons, setSelectedAddons] = useState({});

  const addToCart = (item) => {
    setCart(prev => {
      const exists = prev.find(i => i.id === item.id);
      if (exists) {
        return prev.map(i => i.id === item.id ? { ...i, qty: i.qty + 1 } : i);
      }
      return [...prev, { ...item, qty: 1 }];
    });
  };

  const removeFromCart = (id) => {
    setCart(prev => prev.filter(i => i.id !== id));
  };

  const updateQuantity = (id, qty) => {
    // If quantity is 0 or less, remove it from the cart
    if (qty <= 0) {
      removeFromCart(id);
    } else {
      setCart(prev => prev.map(i => i.id === id ? { ...i, qty } : i));
    }
  };

  const updateCartItem = (id, updates) => {
    setCart(prev => prev.map(i => i.id === id ? { ...i, ...updates } : i));
  };

  const total = cart.reduce((acc, item) => acc + item.price * item.qty, 0);

  return (
    <CartContext.Provider value={{
      cart,
      setCart,
      addToCart,
      removeFromCart,
      updateCartItem,
      updateQuantity,
      total,
      isOpen,
      setIsOpen,
      selectedAddons,
      setSelectedAddons,
    }}>
      {children}
    </CartContext.Provider>
  );
};
